import {
  BadgeHelpIcon,
  Bell,
  BellIcon,
  FileTextIcon,
  HistoryIcon,
  MessagesSquareIcon,
  SettingsIcon,
  TvMinimal,
  UserPenIcon,
  UsersIcon,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const options = {
  profile: [
    { name: 'Edit Profile', to: '/buyer/edit-profile', icon: UserPenIcon },
    { name: 'Documents', to: '/buyer/documents', icon: FileTextIcon },
    { name: 'Teams', to: '/buyer/teams', icon: UsersIcon },
    { name: 'History', to: '/buyer/history', icon: HistoryIcon },
    { name: 'Subscriptions', to: '/buyer/subscriptions', icon: TvMinimal },
  ],
  other: [
    { name: 'Chat', to: '/buyer/chat', icon: MessagesSquareIcon },
    { name: 'Notification', to: '/buyer/notification', icon: BellIcon },
    { name: 'Help & Support', to: '/buyer/help-support', icon: BadgeHelpIcon },
    { name: 'Setting', to: '/buyer/setting', icon: SettingsIcon },
  ],
};

const BuyerDashboardSidebar = () => {
  return (
    <div className="w-full px-4">
      {/* Profile Section */}
      <div className="mb-6">
        <h2 className="text-slate-500 text-xs font-semibold uppercase mb-4">
          Profile
        </h2>
        <ul className="space-y-6">
          {options.profile.map((item, index) => (
            <li key={index}>
              <Link
                to={item.to}
                className="flex items-center text-sm text-slate-500 hover:text-darkPurple cursor-pointer"
              >
                <span className="mr-2">
                  <item.icon className="h-5 w-5" aria-hidden="true" />
                </span>{' '}
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Other Section */}
      <div>
        <h2 className="text-slate-500 text-xs font-semibold uppercase mb-4">
          Other
        </h2>
        <ul className="space-y-6">
          {options.other.map((item, index) => (
            <li key={index}>
              <Link
                to={item.to}
                className="flex items-center text-sm text-slate-500 hover:text-darkPurple cursor-pointer"
              >
                <span className="mr-2">
                  <item.icon className="h-5 w-5" aria-hidden="true" />
                </span>{' '}
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BuyerDashboardSidebar;
